import { INSTANCE, INSTANCELIST } from './API.js'

export const getProductStockHistory = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter, tabFilter } = queryKey[1]
    INSTANCELIST({
      method: 'get',
      url: '/fixed-sku-stock-history',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort || ['createdAt', 'DESC']),
        range: JSON.stringify(range || [0, 99]),
        filter: JSON.stringify(filter || {}),
        ...tabFilter,
      },
    })
      .then(resolve)
      .catch(reject)
  })
